













import { Component, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Info: () => import('@/components/Info.vue')
  }
})
export default class Footer extends Vue {
  private URL_WEB = process.env.VUE_APP_TYPE_WEB
}
